import { deliveryGiantMessageId } from '../../../../../../domain/economy/deliveryGiantMessage';
import type { DeliveryUrgency } from '../../../../../../domain/economy/types';
import type { DeliveryPopupTail } from './deliveryPopupLayout';
import { deliveryPopupMoodId } from './deliveryPopupMood';
import {
  buildDeliveryPopupMessageTextShadow,
  DELIVERY_POPUP_MESSAGE_FONT_SIZE,
  getDeliveryPopupMessage,
} from './deliveryPopupMessages';
import './DeliveryPopupMessage.css';

type DeliveryPopupMessageProps = {
  urgency: DeliveryUrgency;
  waitingDay: number;
  tail?: DeliveryPopupTail;
};

/** GDD hero message text — Matias with mood-colored outside stroke via CSS. */
export function DeliveryPopupMessage({
  urgency,
  waitingDay,
  tail = 'down',
}: DeliveryPopupMessageProps) {
  const messageId = deliveryGiantMessageId(urgency, waitingDay);
  const moodId = deliveryPopupMoodId(urgency, waitingDay);
  const message = getDeliveryPopupMessage(messageId, tail);
  const { layout } = message;
  const fontSize = message.fontSize ?? DELIVERY_POPUP_MESSAGE_FONT_SIZE;

  return (
    <p
      className={[
        'delivery-popup-message',
        `delivery-popup-message--${moodId}`,
      ].join(' ')}
      style={{
        left: layout.left,
        top: layout.top,
        width: layout.width,
        height: layout.height,
        fontSize,
        textShadow: buildDeliveryPopupMessageTextShadow(message.stroke),
      }}
    >
      {message.lines.map((line, index) => (
        <span key={line} className="delivery-popup-message__line">
          {line}
        </span>
      ))}
    </p>
  );
}
